import { calculateDistance } from "@/lib/geohash";
import type { Coordinates } from "@/lib/location-ranking";

/** Keep the branch identity with its distance so labels and map pins agree. */
export function getNearbyLocation<
  T extends Coordinates & { isPrimary?: boolean },
>(
  locations: readonly T[],
  viewer: Coordinates | null | undefined,
): { location: T | null; distanceKm: number | null } {
  const valid = locations.filter(
    ({ latitude, longitude }) =>
      Number.isFinite(latitude) &&
      Math.abs(latitude) <= 90 &&
      Number.isFinite(longitude) &&
      Math.abs(longitude) <= 180,
  );
  let location = valid.find((point) => point.isPrimary) ?? valid[0] ?? null;
  let distanceKm: number | null = null;
  if (viewer) {
    for (const point of valid) {
      const distance = calculateDistance(
        viewer.latitude,
        viewer.longitude,
        point.latitude,
        point.longitude,
      );
      if (
        Number.isFinite(distance) &&
        (distanceKm === null || distance < distanceKm)
      ) {
        location = point;
        distanceKm = distance;
      }
    }
  }
  return { location, distanceKm };
}

/** The same precision on cards and detail pages; round only for display. */
export function formatLocationDistance(km: number): string {
  return km < 1 ? `${Math.round(km * 1000)} m` : `${km.toFixed(1)} km`;
}
